import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=4cad4fb0&scoped=true&lang=pug"
import script from "./CompanyEditor.vue?vue&type=script&lang=ts"
export * from "./CompanyEditor.vue?vue&type=script&lang=ts"
import style0 from "./CompanyEditor.vue?vue&type=style&index=0&id=4cad4fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad4fb0",
  null
  
)

export default component.exports